import request from '@/utils/request'

// 查询赛区管理列表
export function listDivision(url,query) {
  return request({
    url: url+'/division/list',
    method: 'get',
    params: query
  })
}
// 查询赛区管理列表
export function getdivision(url,id) {
  return request({
    url: url+'/division/'+id,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/division/division.js